export const orderStages = [
  {
    id: 1,
    title: "Proposal Created",
    subTitle: "Your Turn",
    message:
      "Explore your personalized dashboard in our journey to find you your ideal candidate for your team. Watch the Orientation video to learn more about what you can expect from our meticulous customer service.",
    cta: "Get Started",
  },
  {
    id: 2,
    title: "Awaiting Meeting Confirmation",
    subTitle: "Your Turn",
    message:
      "Now that you’ve learned more about how we approach your goal to find you the best candidate possible, let’s get on a call together to discuss the details.",
    cta: "Book Meeting with Us",
  },
  {
    id: 3,
    title: "Upcoming Meeting",
    subTitle: "Upcoming",
    message:
      "Upcoming Meeting. Your meeting is scheduled for: [Date]. Click below to save it to your Apple, Google, or Outlook calendar, download the .ICS, or email or text it to yourself.",
    cta: "While you wait, check this out:",
  },
  {
    id: 4,
    title: "Preparing Your Proposal",
    subTitle: "Our Turn",
    message:
      "Preparing Your Proposal. Thanks for chatting with us. We’re currently working on preparing your Services Proposal, Presentation and Contract, so that we can begin working together as soon as possible. We’ll be in touch shortly!",
    cta: "While you wait, check this out:",
  },
  {
    id: 5,
    title: "Awaiting Proposal Review & Signature",
    subTitle: "Your Turn",
    message:
      "We’ve enjoyed chatting with you so far and we can’t wait to get started. Please take your time to review the proposal and contract and don’t hesitate to reach out if you have any questions. We can’t wait to get started!",
    action: "Waiting for them to sign the proposal and contract using PandaDoc",
    cta: "Review Proposal",
  },
  {
    id: 6,
    title: "Awaiting Payment",
    subTitle: "Your Turn",
    message:
      "We’re almost there! Submit your retainer payment in order to get started.",
    action:
      "Once payment is received, the order status automatically changes once to ‘Search Started’.",
    cta: "Pay Now",
  },
  {
    id: 7,
    title: "Search Started",
    subTitle: "Our Turn",
    message:
      "Take-Off! Thanks for trusting us as your exclusive recruitment partner. We’re so happy to get started working with you.",
    action:
      "Showcase this message once upon successful payment, but quickly switch to",
    cta: "Download Documents",
  },
  {
    id: 8,
    title: "Search In-Progress",
    subTitle: "Our Turn",
    message:
      "Thanks for being an awesome and patient partner! We’re currently working very hard behind the scenes to find the absolute best prospects for you. Hang in there!",
    action:
      "In the process of completing the fulfillment of shortlisted candidates.",
    cta: "While you wait, check out this (Resource)",
  },
  {
    id: 9,
    title: "Shortlist Ready",
    subTitle: "Your Turn",
    message:
      "We’ve got ‘em! Your candidate shortlist is ready for you. To reveal the list of the amazing candidates we’ve found, please pay your second of three performanced-based payments.",
    action:
      "Once the employer has submitted the second payment, the candidate shortlist is revealed. Before payment, you can showcase certain characteristics or details about the candidates without revealing their full identity (blurring out certain aspects of the full list).",
    cta: "Pay Now & Reveal Shortlist",
  },
  {
    id: 10,
    title: "Review Shortlisted Candidates",
    subTitle: "Your Turn",
    message:
      "Drum Roll Please…. Ta-Da! Here’s our recommendations for the best candidates on the market that are a perfect fit for you and your team. Take some time to read their profiles, listen to their Q&As and their interviews, and let us know what you think!",
    action:
      "Once they have reviewed the candidates, we’ll reach out for a conversation with them about how to proceed with interviewing 1+ of the shortlisted candidates.",
    cta: "Review Candidates",
  },
  {
    id: 11,
    title: "Scheduling Candidate Interviews",
    subTitle: "Our Turn",
    message:
      "Thanks for your awesome selection! We’re currently reaching out to your selected candidates as we speak and we’ll soon let you know when we have the interviews scheduled and ready for you!",
    action: "Schedule interviews with the candidates",
    cta: "While you wait, check out this (Resource)",
  },
  {
    id: 12,
    title: "Awaiting Offer Response",
    subTitle: "Our Turn",
    message:
      "Wow - we can see the finish line now! Thanks for being an amazing partner throughout this whole journey. We’re waiting on your selected candidate to make his final decision about your amazing offer. We’ll be in touch very soon with a decision!",
    action:
      "Negotiate and deal with the offer presented to the candidate behind the scenes.",
    cta: "While you wait, check out this (Resource)",
  },
  {
    id: 13,
    title: "Search Complete",
    subTitle: "Our Turn",
    message:
      "That’s All Folks! Woo-Hoo! We’re so excited for you and your new team member! We can’t wait to see the amazing things [Candidate Name] will accomplish for your organization. As with all happy endings, our partnership together has now come to an end. We’re available any time if you have any additional questions or requests - please never shy away from reaching out. We would kindly ask for you to submit the third and final performance-based payment to finalize the search and bring this contract to a happy close. Thanks again!",
    action:
      "The client submits the third and final payment and the contract is terminated.",
    cta: "Pay Now & Finalize Search",
  },
]
